module.exports = __webpack_public_path__ + "static/video-8bed28ed7dd131e62c0ba71b81625bd8.mp4";